import React, { useRef, useState, useEffect } from "react";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  convertToPixelCrop,
} from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { Modal, Box, Typography, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import SubmitButton from "../../common/submitButton";
import SaveButton from "../../common/saveButton";
import commonActions from "../../redux/common/actions";
import { useDispatch } from "react-redux";
import axios from "axios";

const MIN_DIMENSION = 300;

export default function ImageCropSignature({
  showModal,
  handleClose,
  image,
  onCropDone,
  onCropCancel,
  setForthErrorList,
  setConfirmationList,
  setLoading,
  setSignatureShowCard,
  setSignatureValue
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();
  const [aspectRatio] = useState(4 / 3);
  const [showComponent, setShowComponent] = useState(false); // Delay state
  const dispatch = useDispatch();

  useEffect(() => {
    if (showModal) {
      setShowComponent(false); // Hide component initially
      dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
      const timer = setTimeout(() => {
        setShowComponent(true);
        dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
        // Show component after 4 seconds
      }, 4000);

      return () => clearTimeout(timer);
    } else {
      setShowComponent(false);
    }
  }, [showModal, image]); // Delay applies whenever modal opens or image changes

  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;

    const initialCrop = makeAspectCrop(
      {
        unit: "%",
        width: (MIN_DIMENSION / width) * 100, // Ensures a minimum dimension crop
      },
      aspectRatio,
      width,
      height
    );
    const centeredCrop = centerCrop(initialCrop, width, height);
    setCrop(centeredCrop);
  };

  const onCropImage = async (e) => {
  if (imgRef.current && crop) {
    const pixelCrop = convertToPixelCrop(
      crop,
      imgRef.current.width,
      imgRef.current.height
    );

    // Get natural dimensions
    const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
    const scaleY = imgRef.current.naturalHeight / imgRef.current.height;

    const canvas = document.createElement("canvas");
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imgRef.current,
      pixelCrop.x * scaleX, // scale crop area
      pixelCrop.y * scaleY,
      pixelCrop.width * scaleX,
      pixelCrop.height * scaleY,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    const dataURL = canvas.toDataURL("image/jpeg", 0.9); 

    const imageSrc = dataURL;
    const formData = new FormData();
    const blob = await fetch(imageSrc).then(res => res.blob());
    console.log(imageSrc,"image src consoeld")
    // const file = e.target.files[0];
    const file = new File([blob], "SIGNATURE.jpg", { type: "image/jpeg" });
    formData.append("file", file);
   setForthErrorList("");
  setConfirmationList("");
   setLoading(true)
    try {
      const response = await axios.post(
        // "https://mh-cet-facesign.hubblehox.ai/sign-detect",
      `${process.env.REACT_APP_AI_BASE_URL}/sign-detect`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.detected == false) {
        setForthErrorList(response?.data?.details ? response?.data?.details : "Signature Not Detected");
      setConfirmationList("");
       dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "failed",
          show: true,
          message: response?.data?.details,
        }
      });
        setTimeout(() => {
        dispatch({
          type: commonActions.SET_ALERT,
          payload: {
            status: null,
            show: false,
            message: null,
          },
        });
      }, 2000);
      } else {
          setConfirmationList(response?.data?.details ? response?.data?.details : "Signature detected.");
      setForthErrorList("");
          onCropDone(dataURL, pixelCrop);
      }
    } catch (error) {
       setForthErrorList("Try again...");
      setConfirmationList("");
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setSignatureShowCard(reader.result); // Show new image
    };
    reader.readAsDataURL(file);
    setSignatureValue(file)
  setLoading(false)
  }
};


  if (!showComponent) {
    return null; // Don't render anything until the delay is complete
  }

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      aria-labelledby="crop-image-signature-modal-title"
      aria-describedby="crop-image-signature-modal-description"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          bgcolor: "background.paper",
          boxShadow: 24,
          p: isMobile ? 2 : 1,
          width: isMobile ? "90%" : 800,
          maxWidth: isMobile ? "100%" : "none",
        }}
      >
        <Typography
          id="crop-image-signature-modal-title"
          variant="h6"
          component="h2"
          pt={1}
          px={2}
        >
          Crop Image Signature
        </Typography>
        <Box
          sx={{
            height: isMobile ? "40vh" : "50vh",
            maxHeight: "70vh",
            overflow: "hidden",
            position: "relative",
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ReactCrop
            crop={crop}
            onChange={(newCrop) => setCrop(newCrop)}
            minWidth={MIN_DIMENSION}
            keepSelection
          >
            <img
              ref={imgRef}
              src={image}
              alt="Crop preview"
              onLoad={onImageLoad}
              style={{ maxHeight: "90vh" }}
            />
          </ReactCrop>
        </Box>

        <Grid container justifyContent="flex-end" spacing={2} sx={{ my: 1 }}>
          <Grid item>
            <SaveButton name="Cancel" handleDraft={onCropCancel} />
          </Grid>
          <Grid item>
            <SubmitButton name="Crop & Apply" handleSubmit={onCropImage} />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
